export default "__VITE_ASSET__BhmDe1_p__"